/* global process */

import "dotenv/config";

export const { API_BASE_URL, FRONTEND_URL, CLIENT_ID, CLIENT_SCOPE, CLIENT_SECRET, GRANT_TYPE } = process.env;
